import React, { useState } from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { MessageBox } from 'components';
import { MeasurementDateDialog } from 'components/MeasurementDates';
import { MissingMeasurementDateMessageProps } from './MissingMeasurementDateMessage.props';

const MissingMeasurementDateMessage = ({ title, tagline }: MissingMeasurementDateMessageProps) => {
  const [{ companyInfo }] = useStore() as unknown as UseStoreValues;
  const [openMeasurementDatesDialog, setOpenMeasurementDatesDialog] = useState(false);

  const OpenMeasurementDatesDialog = () => (
    <Button
      id="add-md-btn"
      variant="outlined"
      color="primary"
      onClick={() => {
        setOpenMeasurementDatesDialog(true);
      }}
      endIcon={<AddIcon />}>
      Add Measurement Date
    </Button>
  );

  return (
    <>
      <MessageBox title={title} tagline={tagline} fullWidth={false} action={<OpenMeasurementDatesDialog />} />
      {openMeasurementDatesDialog && companyInfo && (
        <MeasurementDateDialog
          open={openMeasurementDatesDialog}
          activeCompany={companyInfo}
          onClose={() => setOpenMeasurementDatesDialog(false)}
        />
      )}
    </>
  );
};

export default MissingMeasurementDateMessage;
